import React from "react";
import { Card, Row, Col } from "antd";

const OverviewCard = ({ data, loading, subscribeCount, expiryCount }) => {
  const subscribed = data.find((d) => d.id === "subscribed_count");
  const unsubscribed = data.find((d) => d.id === "unsubscribed_count");
  const p1 = data.find((d) => d.id === "p1");
  const p2 = data.find((d) => d.id === "p2");
  const p3 = data.find((d) => d.id === "p3");

  return (
    <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
      <Col span={24}>
        <Card
          loading={loading}
          title="User Subscription and Priority Overview"
          bordered={false}
          style={{
            borderRadius: 12,
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            backgroundColor: "#80ceedff",
            color: "black",
            fontWeight: "bold",
          }}
          //   headStyle={{ color: "black" }}
        >
          <Row gutter={[16, 16]} justify="center">
            {/* Subscribed & Unsubscribed */}
            <Col xs={24} sm={12} md={6} style={{ textAlign: "center", wordWrap: "break-word" }}>
              <h3>Total Subscribed deals</h3>
              <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>{subscribed?.details}</p>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={6}
              style={{
                textAlign: "center",
                borderRight: "1px solid white",
                wordWrap: "break-word",
              }}
            >
              <h3>Total Unsubscribed deals</h3>
              <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>{unsubscribed?.details}</p>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={6}
              style={{
                textAlign: "center",
                // borderRight: "1px solid white",
                wordWrap: "break-word",
              }}
            >
              <h3>Subscription Count</h3>
              <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>{subscribeCount}</p>
            </Col>
            <Col
              xs={24}
              sm={12}
              md={6}
              style={{
                textAlign: "center",
                borderRight: "1px solid white",
                wordWrap: "break-word",
              }}
            >
              <h3>Expired Subscription Count</h3>
              <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>{expiryCount}</p>
            </Col>

            {/* Priority Section */}
            <Col xs={24} md={12} style={{ textAlign: "center" }}>
              {/* <h3>Priority Count</h3> */}
              <Row
                justify="space-around"
                gutter={[8, 8]}
                style={{
                  marginTop: 12,
                  display: "flex",
                  flexWrap: "wrap",
                  wordWrap: "break-word",
                }}
              >
                {[p1, p2, p3].filter(Boolean).map((p, i) => (
                  <Col
                    xs={8}
                    key={p.id}
                    style={{
                      textAlign: "center",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: "100%",
                    }}
                  >
                    <h4>P{i + 1}</h4>
                    <p
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        margin: 0,
                        wordBreak: "break-word",
                      }}
                      title={p.details}
                    >
                      {p.details}
                    </p>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default OverviewCard;

// import React from "react";
// import { Card, Row, Col } from "antd";

// const OverviewCard = ({ data }) => {
//   const subscribed = data.find((d) => d.id === "subscribed_count");
//   const unsubscribed = data.find((d) => d.id === "unsubscribed_count");
//   const p1 = data.find((d) => d.id === "p1");
//   const p2 = data.find((d) => d.id === "p2");
//   const p3 = data.find((d) => d.id === "p3");

//   return (
//     <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
//       <Col span={24}>
//         <Card title="User Subscription and Priority Overview" bordered={false}>
//           <Row gutter={[16, 16]} justify="space-around" align="middle">
//             {/* Subscribed & Unsubscribed */}
//             <Col span={6} style={{ textAlign: "center" }}>
//               <h3>Subscribed</h3>
//               <p style={{ fontSize: "24px", fontWeight: "bold" }}>{subscribed.details}</p>
//             </Col>
//             <Col span={6} style={{ textAlign: "center" }}>
//               <h3>Unsubscribed</h3>
//               <p style={{ fontSize: "24px", fontWeight: "bold" }}>{unsubscribed.details}</p>
//             </Col>

//             {/* Priority Section */}
//             <Col span={12}>
//               <h3 style={{ textAlign: "center" }}>Priority Count</h3>
//               <Row justify="space-around" style={{ marginTop: 12 }}>
//                 <Col style={{ textAlign: "center" }}>
//                   <h4>P1</h4>
//                   <p style={{ fontSize: "20px", fontWeight: "bold" }}>{p1.details}</p>
//                 </Col>
//                 <Col style={{ textAlign: "center" }}>
//                   <h4>P2</h4>
//                   <p style={{ fontSize: "20px", fontWeight: "bold" }}>{p2.details}</p>
//                 </Col>
//                 <Col style={{ textAlign: "center" }}>
//                   <h4>P3</h4>
//                   <p style={{ fontSize: "20px", fontWeight: "bold" }}>{p3.details}</p>
//                 </Col>
//               </Row>
//             </Col>
//           </Row>
//         </Card>
//       </Col>
//     </Row>
//   );
// };

// export default OverviewCard;
